module.exports = __webpack_public_path__ + "static/img/ico_s_market@2x.fb243bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_s_market@2x.png
// module id = qbRE
// module chunks = 0